(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_pivot-header-item-free"] && !Shopify.designMode) return;
  try {
    class PvtMegamenuFree extends HTMLElement {
    constructor() {
      super();
      this.$detail = this.querySelector('details');
      this.$trigger = this.$detail.querySelector('summary');
      this.$dropdown = this.$detail.querySelector('.pivot-megamenu-item__dropdown');
      this.$parent = this.closest('.shopify-section');
      this.openMode = this.dataset.openMode;
      this.hideDebounce = 0;

      // Evita que un click en el título-link abra/cierre el <details>
      const $titleLink = this.$trigger.querySelector('.pivot-megamenu-free__title-link');
      if ($titleLink) {
        $titleLink.addEventListener('click', (e) => e.stopPropagation());
      }

      // Cerrar el menú al esconder el header
      if (this.$parent) {
        const observer = new MutationObserver((entries) => {
          entries.forEach((entry) => {
            if (!this.$detail.open) return;
            const clss = this.$parent.getAttribute('class');
            if (clss === entry.oldValue) return;
            this.$detail.open = !this.$parent.classList.contains('shopify-section-header-hidden');
          });
        });
        observer.observe(this.$parent, {
          attributeFilter: ['class'],
          attributes: true,
          attributeOldValue: true,
        });
      }

      // Cerrar al salir del dropdown
      this.$dropdown.addEventListener(
        'mouseleave',
        (e) => {
          if (e.target === this.$dropdown) {
            this.$detail.open = false;
          }
        },
        false
      );

      // Abrir en hover del trigger
      if (this.openMode === 'hover') {
        this.$trigger.addEventListener('mouseover', () => {
          this.$detail.open = true;
        });
      }

      // Ocultar al salir del trigger (con debounce por si entra al dropdown)
      this.$trigger.addEventListener('mouseleave', () => {
        this.hideDebounce = setTimeout(() => {
          this.$detail.open = false;
        }, 250);
      });
      this.$dropdown.addEventListener('mouseover', () => {
        if (this.hideDebounce) clearTimeout(this.hideDebounce);
      });
    }
  }
  if (!customElements.get('pvt-megamenu-free')) {
    customElements.define('pvt-megamenu-free', PvtMegamenuFree);
  }

  // Cierre automático de otros ítems del megamenú al abrir uno.
  // Se registra una sola vez aunque coexista con "Menu item".
  if (!window.__pvtMegamenuAutoclose) {
    window.__pvtMegamenuAutoclose = true;
    const stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader) {
      const selector =
        'sticky-header .list-menu--inline > li > header-menu > details, sticky-header .list-menu--inline > li > pvt-megamenu-item > details, sticky-header .list-menu--inline > li > pvt-megamenu-free > details';
      const openObserver = new MutationObserver((entries) =>
        entries.forEach((entry) => {
          const parentName = entry.target.parentElement.tagName.toLowerCase();
          if (
            !entry.target.open ||
            (parentName != 'header-menu' && parentName != 'pvt-megamenu-item' && parentName != 'pvt-megamenu-free')
          )
            return;
          document.querySelectorAll(selector).forEach((el) => {
            if (el !== entry.target) el.open = false;
          });
        })
      );
      openObserver.observe(stickyHeader, {
        attributes: true,
        attributeFilter: ['open'],
        subtree: true,
      });
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_pivot-header-item"] && !Shopify.designMode) return;
  try {
    let globalMMTimeout = 0;

  class PvtMegamenuItem extends HTMLElement {
    constructor() {
      super();
      this.$detail = this.querySelector('details');
      this.$trigger = this.$detail.querySelector('summary');
      this.$dropdown = this.$detail.querySelector('.pivot-megamenu-item__dropdown');
      this.$aside = this.querySelector('.pivot-megamenu-item__main-aside ul');
      this.$subItemsWrapper = this.querySelector('.pivot-megamenu-item__subitems');
      this.$parent = this.closest('.shopify-section');
      this.openMode = this.dataset.openMode;
      this.sidemenuBehavior = this.dataset.sidemenuBehavior;
      this.isTouch = window.matchMedia('(hover:none)');
      this.hideDebounce = 0;

      // Cerrar el menu al esconder el header
      const observer = new MutationObserver((entries) => {
        entries.forEach((entry) => {
          if (!this.$detail.open) return;
          const clss = this.$parent.getAttribute('class');
          if (clss === entry.oldValue) return;
          this.$detail.open = !this.$parent.classList.contains('shopify-section-header-hidden');
        });
      });
      observer.observe(this.$parent, {
        attributeFilter: ['class'],
        attributes: true,
        attributeOldValue: true,
      });

      // Cerrar al clickear fuera
      this.$dropdown.addEventListener(
        'mouseleave',
        (e) => {
          if (e.target === this.$dropdown) {
            this.$detail.open = false;
          }
        },
        false
      );

      // Hover en los elementos internos
      const openMenu = (e) => {
        e.preventDefault();
        clearTimeout(globalMMTimeout);
        globalMMTimeout = setTimeout(() => {
          const $newMenuActive = this.$aside.querySelector('.pivot-megamenu-item__main-aside-link:hover');
          if (!$newMenuActive) return;

          const $currentMenuActive = this.$aside.querySelector('.active');
          const $currentGridActive = this.$subItemsWrapper.querySelector('.active');

          if ($currentMenuActive) $currentMenuActive.classList.remove('active');
          if ($currentGridActive) $currentGridActive.classList.remove('active');

          $newMenuActive.classList.add('active');
          this.$subItemsWrapper.querySelector(`#${$newMenuActive.dataset.item}`)?.classList.add('active');
        }, 70);
      };
      this.$aside.addEventListener(
        this.sidemenuBehavior === 'navigate' && !this.isTouch.matches ? 'mouseover' : 'click',
        openMenu
      );

      this.$subItemsWrapper.addEventListener('mouseover', () => clearTimeout(globalMMTimeout));
      // Hover en el trigger
      if (this.openMode === 'hover')
        this.$trigger.addEventListener('mouseover', () => {
          this.$detail.open = true;
        });

      // Ocultar al salir del trigger
      this.$trigger.addEventListener('mouseleave', (e) => {
        this.hideDebounce = setTimeout(() => {
          this.$detail.open = false;
        }, 250);
      });
      this.$dropdown.addEventListener('mouseover', () => {
        if (this.hideDebounce) clearTimeout(this.hideDebounce);
      });
    }
  }
  if (!customElements.get('pvt-megamenu-item')) {
    customElements.define('pvt-megamenu-item', PvtMegamenuItem);

    // Abrir/cerrar otros elementos del megamenú
    const stickyHeader = document.querySelector('sticky-header');
    console.log('Cierre atomático details', stickyHeader);
    const summaries = document.querySelectorAll(
      'sticky-header .list-menu--inline > li > header-menu > details, sticky-header .list-menu--inline > li > pvt-megamenu-item > details, sticky-header .list-menu--inline > li > pvt-megamenu-free > details'
    );

    const openObserver = new MutationObserver((entries) =>
      entries.forEach((entry) => {
        console.log('entry', entry);
        const parentName = entry.target.parentElement.tagName.toLowerCase();
        console.log('ParentName', parentName);
        if (
          !entry.target.open ||
          (parentName != 'header-menu' && parentName != 'pvt-megamenu-item' && parentName != 'pvt-megamenu-free')
        )
          return;
        // console.log('Abrimos', entry.target)
        summaries.forEach((el) => {
          console.log('Elemento', el);
          if (el !== entry.target) el.open = false;
        });
      })
    );

    // Subscribir todos los summaries
    openObserver.observe(stickyHeader, {
      attributes: true,
      attributeFilter: ['open'],
      subtree: true,
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_pivot-header-items-group"] && !Shopify.designMode) return;
  try {
    class PvtMobileDrawer extends HTMLElement {
    constructor() {
      super();
      this.mql = window.matchMedia('(max-width: 749px)');
      this.currentTabs = null; // <pvt-megamenu-free-tabs> abierto en N1
      this._titles = ['', '', '']; // título de la barra por nivel
      this._onKeydown = this._onKeydown.bind(this);
      this._onMediaChange = this._onMediaChange.bind(this);
    }

    connectedCallback() {
      this.$toggle = this.querySelector('[ref="toggle"]');
      this.$backdrop = this.querySelector('[ref="backdrop"]');
      this.$panel = this.querySelector('[ref="panel"]');
      this.$back = this.querySelector('[ref="back"]');
      this.$title = this.querySelector('[ref="title"]');
      this.$close = this.querySelector('[ref="close"]');
      this.$track = this.querySelector('[ref="track"]');
      this.$root = this.querySelector('[ref="root"]');
      this.$tabs = this.querySelector('[ref="tabs"]');
      this.$slot = this.querySelector('[ref="slot"]');
      this.$cta = this.querySelector('[ref="cta"]');

      this.$group = this.closest('.pivot-header__nav');
      this._caretHTML = this.$back
        ? this.$back.querySelector('.pvt-mmd__back-icon').innerHTML
        : '';

      this.buildRoot();

      this.$toggle.addEventListener('click', () => this.open());
      this.$close.addEventListener('click', () => this.close());
      this.$back.addEventListener('click', () => this.back());
      this.$backdrop.addEventListener('click', () => this.close());

      this.mql.addEventListener('change', this._onMediaChange);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this._onKeydown);
      this.mql.removeEventListener('change', this._onMediaChange);
      this._clearSlot();
      this._unlockScroll();
    }

    /* --------- Nivel 0: construir la lista raíz de items --------- */
    buildRoot() {
      if (!this.$root || !this.$group) return;
      this.$root.textContent = ''; // idempotente
      if (this.$cta) this.$cta.textContent = '';

      const items = this.$group.querySelectorAll(
        '.pivot-header__menu > .pivot-header__menu-item'
      );
      items.forEach((li) => {
        if (li.classList.contains('item-hidden-mobile')) return;

        const tabs = li.querySelector('pvt-megamenu-free-tabs');
        if (!tabs) return;

        const title = tabs.getAttribute('data-pvt-title') || '';
        const link = tabs.getAttribute('data-pvt-link') || '';
        const tabTitles = tabs.querySelectorAll('.pvt-free-tab__title');

        const li2 = document.createElement('li');
        li2.className = 'pvt-mmd__list-item';

        if (tabTitles.length) {
          const btn = this._makeRow(title, true);
          btn.addEventListener('click', () => this.openItem(tabs, title));
          li2.appendChild(btn);
        } else if (link && tabs.hasAttribute('data-pvt-button') && this.$cta) {
          const a = document.createElement('a');
          a.className = 'pvt-mmd__row button-secondary pvt-nav-button pvt-mmd__cta-button' + (tabs.hasAttribute('data-pvt-button-outline') ? ' pvt-nav-button--outline' : '');
          a.href = link;
          a.appendChild(this._rowText(title));
          this.$cta.appendChild(a);
          this.$cta.hidden = false;
          return;
        } else if (link) {
          const a = document.createElement('a');
          a.className = 'pvt-mmd__row';
          a.href = link;
          a.appendChild(this._rowText(title));
          li2.appendChild(a);
        } else {
          return;
        }
        this.$root.appendChild(li2);
      });
    }

    /* --------- Nivel 1: listar las pestañas del item --------- */
    openItem(tabs, title) {
      this.currentTabs = tabs;
      this.$tabs.textContent = '';

      // Emparejamos cada título con SU panel hermano recorriendo el grid en orden
      // de documento. Cada .pvt-free-tab__title va seguido de su .pvt-free-tab__panel-wrap;
      // buscar el siguiente wrap tras cada título es robusto aunque el título sea un
      // <a href> (Facturadores) y aunque haya un link "view-all" al final.
      const grid = tabs.querySelector('.pivot-megamenu-free__grid') || tabs;
      const nodes = Array.from(
        grid.querySelectorAll('.pvt-free-tab__title, .pvt-free-tab__panel-wrap')
      );

      nodes.forEach((node, idx) => {
        if (!node.classList.contains('pvt-free-tab__title')) return;

        const titleEl = node;
        // El panel de esta pestaña es el siguiente .pvt-free-tab__panel-wrap.
        let wrap = null;
        for (let j = idx + 1; j < nodes.length; j++) {
          if (nodes[j].classList.contains('pvt-free-tab__panel-wrap')) {
            wrap = nodes[j];
            break;
          }
          if (nodes[j].classList.contains('pvt-free-tab__title')) break;
        }

        const label = (titleEl.textContent || '').trim();
        const iconImg = titleEl.querySelector('.pvt-aside-icon img');
        const panel = wrap ? wrap.querySelector('.pvt-free-tab__panel') : null;
        const hasContent = panel && panel.children.length;

        const li = document.createElement('li');
        li.className = 'pvt-mmd__list-item';

        // Con contenido → SIEMPRE botón que abre N2 (aunque el título tenga href).
        // Sin contenido pero con href real → link directo.
        if (hasContent) {
          const btn = this._makeRow(label, true, iconImg);
          btn.addEventListener('click', () => this.openTab(wrap, label));
          li.appendChild(btn);
        } else {
          const href = titleEl.getAttribute('href');
          const a = document.createElement('a');
          a.className = 'pvt-mmd__row';
          a.href = href && href !== '#' ? href : '#';
          if (iconImg) a.appendChild(this._rowIcon(iconImg));
          a.appendChild(this._rowText(label));
          li.appendChild(a);
        }
        this.$tabs.appendChild(li);
      });

      this._titles[1] = title;
      this._setLevel(1);
    }

    /* --------- Nivel 2: clonar el contenido de la pestaña en el slot ---------
       Clonamos (no movemos) el .pvt-free-tab__panel: así el nodo del drawer es
       independiente del JS/CSS de desktop (que togglea .active por hover y oculta
       los paneles no activos), evitando que el contenido se vacíe tras un instante.
       El contenido ya está renderizado (imágenes con URL), el clon es idéntico. */
    openTab(wrap, label) {
      this.$slot.textContent = '';
      const panel = wrap.querySelector('.pvt-free-tab__panel');
      if (panel) {
        const clone = panel.cloneNode(true);
        clone.classList.add('pvt-mmd__cloned-panel');
        this.$slot.appendChild(clone);
      }

      this._titles[2] = label;
      this._setLevel(2);
      this._focusSlot();
    }

    /* --------- Retroceder / cerrar --------- */
    back() {
      const level = this._level();
      if (level <= 0) return;

      if (level === 2) {
        this._setLevel(1);
        this._clearSlotAfterTransition();
      } else if (level === 1) {
        this._setLevel(0);
      }
    }

    open() {
      if (this.classList.contains('is-open')) return;
      this._setLevel(0);
      this.classList.add('is-open');
      this.$toggle.setAttribute('aria-expanded', 'true');
      this._lockScroll();
      document.addEventListener('keydown', this._onKeydown);
      this._trapFocus();
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.$toggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', this._onKeydown);
      this._unlockScroll();

      const finish = () => {
        this._setLevel(0);
        this._clearSlot();
        this.$panel.removeEventListener('transitionend', onEnd);
      };
      const onEnd = (e) => {
        if (e.target === this.$panel && e.propertyName === 'transform') finish();
      };
      this.$panel.addEventListener('transitionend', onEnd);
      setTimeout(finish, 400); // fallback (reduced motion, etc.)

      if (this.$toggle) this.$toggle.focus();
    }

    /* --------- Helpers de nivel / título --------- */
    _level() {
      return parseInt(this.$track.getAttribute('data-level') || '0', 10);
    }
    _setLevel(n) {
      this.$track.setAttribute('data-level', String(n));
      this._setTitle(this._titles[n] || '');
      if (this.$back) this.$back.hidden = n <= 0;
    }
    _setTitle(t) {
      if (this.$title) this.$title.textContent = t || '';
    }

    _clearSlotAfterTransition() {
      const onEnd = (e) => {
        if (e.target === this.$track && e.propertyName === 'transform') {
          this._clearSlot();
          this.$track.removeEventListener('transitionend', onEnd);
        }
      };
      this.$track.addEventListener('transitionend', onEnd);
      setTimeout(() => this._clearSlot(), 400);
    }

    _clearSlot() {
      if (this.$slot) this.$slot.textContent = '';
    }

    /* --------- Constructores de filas --------- */
    _makeRow(label, withCaret, iconImg) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pvt-mmd__row';
      if (iconImg) btn.appendChild(this._rowIcon(iconImg));
      btn.appendChild(this._rowText(label));
      if (withCaret) {
        const caret = document.createElement('span');
        caret.className = 'pvt-mmd__row-caret';
        caret.innerHTML = this._caretHTML;
        btn.appendChild(caret);
      }
      return btn;
    }
    _rowText(label) {
      const span = document.createElement('span');
      span.className = 'pvt-mmd__row-text';
      span.textContent = label;
      return span;
    }
    _rowIcon(img) {
      const span = document.createElement('span');
      span.className = 'pvt-mmd__row-icon';
      const clone = img.cloneNode(true);
      clone.removeAttribute('loading');
      span.appendChild(clone);
      return span;
    }

    /* --------- Scroll lock --------- */
    _lockScroll() {
      document.documentElement.style.overflow = 'hidden';
    }
    _unlockScroll() {
      document.documentElement.style.overflow = '';
    }

    /* --------- Focus trap / Escape --------- */
    _onKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        if (this._level() > 0) this.back();
        else this.close();
        return;
      }
      if (e.key === 'Tab') this._handleTab(e);
    }
    _focusables() {
      return Array.from(
        this.$panel.querySelectorAll(
          'a[href], button:not([disabled]):not([hidden]), input, [tabindex]:not([tabindex="-1"])'
        )
      ).filter((el) => el.offsetParent !== null);
    }
    _handleTab(e) {
      const items = this._focusables();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
    _trapFocus() {
      const items = this._focusables();
      if (items.length) items[0].focus();
    }
    _focusSlot() {
      const target = this.$slot.querySelector('a[href], button');
      if (target) target.focus();
      else if (this.$back) this.$back.focus();
    }

    /* --------- Cambio de viewport --------- */
    _onMediaChange(e) {
      if (!e.matches) {
        this.classList.remove('is-open');
        this.$toggle.setAttribute('aria-expanded', 'false');
        this._unlockScroll();
        this.$track.setAttribute('data-level', '0');
        this._clearSlot();
        if (this.$back) this.$back.hidden = true;
      }
    }
  }

  if (!customElements.get('pvt-mobile-drawer')) {
    customElements.define('pvt-mobile-drawer', PvtMobileDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pivot-header-free-tabs"] && !Shopify.designMode) return;
  try {
    let globalFreeTabsTimeout = 0;

  class PvtMegamenuFreeTabs extends HTMLElement {
    constructor() {
      super();
      this.$detail = this.querySelector('details');
      this.$trigger = this.$detail.querySelector('summary');
      this.$dropdown = this.$detail.querySelector('.pivot-megamenu-item__dropdown');
      this.$grid = this.querySelector('.pivot-megamenu-free__grid');
      this.$parent = this.closest('.shopify-section');
      this.openMode = this.dataset.openMode;
      this.sidemenuBehavior = this.dataset.sidemenuBehavior;
      this.isTouch = window.matchMedia('(hover:none)');
      this.hideDebounce = 0;
      // Pestaña sin contenido (p. ej. un enlace mostrado como botón): nunca abre el desplegable,
      // así el header no cambia de estado al pasar el mouse.
      this.noDropdown = !this.querySelector('.pvt-free-tab__title');
      if (this.noDropdown) {
        this.$detail.addEventListener('toggle', () => {
          if (this.$detail.open) this.$detail.open = false;
        });
        this.$trigger.addEventListener('click', (e) => {
          if (!e.target.closest('a')) e.preventDefault();
        });
      }

      const $titleLink = this.$trigger.querySelector('.pivot-megamenu-free__title-link');
      if ($titleLink) {
        $titleLink.addEventListener('click', (e) => e.stopPropagation());
      }

      if (this.$parent) {
        const observer = new MutationObserver((entries) => {
          entries.forEach((entry) => {
            if (!this.$detail.open) return;
            const clss = this.$parent.getAttribute('class');
            if (clss === entry.oldValue) return;
            this.$detail.open = !this.$parent.classList.contains('shopify-section-header-hidden');
          });
        });
        observer.observe(this.$parent, {
          attributeFilter: ['class'],
          attributes: true,
          attributeOldValue: true,
        });
      }

      this.$dropdown.addEventListener(
        'mouseleave',
        (e) => {
          if (e.target === this.$dropdown) {
            this.$detail.open = false;
          }
        },
        false
      );

      const activate = ($title) => {
        if (!$title || !this.$grid) return;
        const $panel = $title.nextElementSibling;
        if (!$panel || !$panel.classList.contains('pvt-free-tab__panel-wrap')) return;

        this.$grid.querySelectorAll('.pvt-free-tab__title.active').forEach((el) => el.classList.remove('active'));
        this.$grid
          .querySelectorAll('.pvt-free-tab__panel-wrap.active')
          .forEach((el) => el.classList.remove('active'));

        $title.classList.add('active');
        $panel.classList.add('active');
      };

      // Activa la primera pestaña por defecto.
      if (this.$grid) {
        activate(this.$grid.querySelector('.pvt-free-tab__title'));

        const switchTab = (e) => {
          const $title = e.target.closest('.pvt-free-tab__title');
          if (!$title) return;
          e.preventDefault();
          clearTimeout(globalFreeTabsTimeout);
          globalFreeTabsTimeout = setTimeout(() => activate($title), 70);
        };
        this.$grid.addEventListener(
          this.sidemenuBehavior === 'navigate' && !this.isTouch.matches ? 'mouseover' : 'click',
          switchTab
        );
      }

      if (this.openMode === 'hover') {
        this.$trigger.addEventListener('mouseover', () => {
          if (this.noDropdown) return;
          this.$detail.open = true;
        });
      }

      this.$trigger.addEventListener('mouseleave', () => {
        this.hideDebounce = setTimeout(() => {
          this.$detail.open = false;
        }, 250);
      });
      this.$dropdown.addEventListener('mouseover', () => {
        if (this.hideDebounce) clearTimeout(this.hideDebounce);
      });
    }
  }
  if (!customElements.get('pvt-megamenu-free-tabs')) {
    customElements.define('pvt-megamenu-free-tabs', PvtMegamenuFreeTabs);
  }

  // Auto-cierre compartido con el resto de ítems del megamenú.
  if (!window.__pvtMegamenuAutoclose) {
    window.__pvtMegamenuAutoclose = true;
    const stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader) {
      const selector =
        'sticky-header .list-menu--inline > li > header-menu > details, sticky-header .list-menu--inline > li > pvt-megamenu-item > details, sticky-header .list-menu--inline > li > pvt-megamenu-free > details, sticky-header .list-menu--inline > li > pvt-megamenu-free-tabs > details';
      const openObserver = new MutationObserver((entries) =>
        entries.forEach((entry) => {
          const parentName = entry.target.parentElement.tagName.toLowerCase();
          if (
            !entry.target.open ||
            (parentName != 'header-menu' &&
              parentName != 'pvt-megamenu-item' &&
              parentName != 'pvt-megamenu-free' &&
              parentName != 'pvt-megamenu-free-tabs')
          )
            return;
          document.querySelectorAll(selector).forEach((el) => {
            if (el !== entry.target) el.open = false;
          });
        })
      );
      openObserver.observe(stickyHeader, {
        attributes: true,
        attributeFilter: ['open'],
        subtree: true,
      });
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pvt-circulo-flujo"] && !Shopify.designMode) return;
  try {
    (function () {
    function layout(el) {
      const ring = el.querySelector('.pvt-circulo__ring');
      const nodes = el.querySelectorAll('.pvt-circulo__node');
      const stagger = parseInt(el.dataset.stagger || '0', 10);
      const count = nodes.length;
      // radio real = mitad del lado renderizado del anillo (respeta el escalado)
      const radius = ring ? ring.offsetWidth / 2 : 0;
      nodes.forEach((node, i) => {
        const angle = (360 / count) * i - 90;
        node.style.setProperty('--angle', angle + 'deg');
        node.style.setProperty('--radius', radius + 'px');
        node.style.setProperty('--delay', i * stagger + 'ms');
      });
    }

    function init(el) {
      if (el.dataset.pvtInit === '1') return;
      el.dataset.pvtInit = '1';
      layout(el);
      // Recalcular al cambiar el tamaño de la ventana
      if (window.ResizeObserver) {
        const ro = new ResizeObserver(() => layout(el));
        const ring = el.querySelector('.pvt-circulo__ring');
        if (ring) ro.observe(ring);
      } else {
        window.addEventListener('resize', () => layout(el));
      }
      if (!('IntersectionObserver' in window)) {
        el.classList.add('is-visible');
        return;
      }
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.3 }
      );
      io.observe(el);
    }

    document.querySelectorAll('.pvt-circulo').forEach(init);

    // Re-ejecuta al editar en el theme editor (al re-renderizar el bloque)
    document.addEventListener('shopify:block:select', (e) => {
      const el = e.target.closest('.pvt-circulo') || e.target.querySelector('.pvt-circulo');
      if (el) layout(el);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
